import { render, staticRenderFns } from "./ArticleMeta.vue?vue&type=template&id=a3114e64&"
import script from "./ArticleMeta.vue?vue&type=script&lang=js&"
export * from "./ArticleMeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports